import { FC } from 'react';
import { color, font, space } from '@design/templateFns';
import styled from 'styled-components';

interface SearchTabsProps {
  tabs: TabButtonProps[];
  activeTab: number;
  onTabChange: (index: number) => void;
}

interface TabButtonProps {
  testId: string;
  label: string;
}

const SearchTabs: FC<SearchTabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <TabWrapper>
      {tabs.map((tab, index) => (
        <TabButton
          key={index}
          data-testid={tab.testId}
          $isActive={activeTab === index}
          onClick={() => onTabChange(index)}
        >
          {tab.label}
        </TabButton>
      ))}
    </TabWrapper>
  );
};

export default SearchTabs;

export const TabWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;

export const TabButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 70px;
  border: 1px solid #e5e5e5;
  border-bottom: none;
  padding: ${({ $isActive }) => ($isActive ? `10px 8px` : `8px 8px`)};
  ${font('eyebrow-sm')};
  text-transform: uppercase;
  text-underline-offset: 4px;
  text-decoration: ${({ $isActive }) => ($isActive ? 'underline' : undefined)};
  text-decoration-color: ${({ $isActive }) => ($isActive ? color('cta') : undefined)};
  text-decoration-thickness: 2px;
  box-shadow: ${({ $isActive }) => ($isActive ? '0 2px 4px rgba(0, 0, 0, 0.4)' : undefined)};
  z-index: ${({ $isActive }) => ($isActive ? 1 : undefined)};
  background-color: rgba(255, 255, 255, 0.95);
  font-weight: ${({ $isActive }) => ($isActive ? '700' : '400')};
  border-radius: 4px 4px 0 0;
  & + & {
    margin-left: -1;
  }
`;
